import { marked } from 'marked';

const removeHtmlTags = (text: string): string => {
    return text.replace(/<\/?[^>]+(>|$)/g, '');
};

export const convertToPlaintext = (text: string): string => {
    const renderer = new marked.Renderer();
    const renderedText = (text ? marked(text, { renderer }) : '') as string;

    return removeHtmlTags(renderedText);
};

export const truncateWholeWords = (text: string, charLength: number, tail: string): string => {
    const biggestWordLength = 50;
    if (typeof text === 'undefined') return text;
    if (text.length <= charLength) return text;
    //.. truncate to about correct lenght
    let truncatedText = text.slice(0, charLength + biggestWordLength);
    //.. now nibble ends till correct length
    while (truncatedText.length > charLength - tail.length) {
        const lastSpace = truncatedText.lastIndexOf(' ');
        if (lastSpace === -1) break;
        truncatedText = truncatedText.slice(0, lastSpace).replace(/[!,.?;:]$/, '');
    }
    return truncatedText + tail;
};
